export default "__VITE_ASSET__BWN2Ip8C__"